import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {RESIDENT_APPLY_PROCESS, RESIDENT_APPLY_STATUS} from '../../../../../../CodeMaster'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {NatSealField, SealField} from './NatSealField'
import {NatBikeParkingUseWithdrawalApplyDetail} from '../../../repository/NatGetBikeParkingUseWithdrawalApply'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import moment from 'moment'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'

interface Props {
    bikeParkingUseWithdrawalApplicationDocumentParam: NatBikeParkingUseWithdrawalApplyDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatBikeParkingUseWithdrawalApplicationDocument: React.FC<Props> = props => {
    const {
        bikeParkingUseWithdrawalApplicationDocumentParam,
        applyStatusInfoList
    } = props

    const {
        applyId, condominiumName,ridgeName, roomNumber,
        applicantFamilyName, applicantFirstName, withdrawalArea,
        withdrawalDate, bikeCarryingOutDate
    } = bikeParkingUseWithdrawalApplicationDocumentParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>バイク置場使用契約解約届</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、バイク置場使用契約を解約したいので、次のとおり届出をいたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('2  使用区画', withdrawalArea)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('3  解約日', renderWithdrawalDate(withdrawalDate))}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('4  バイク搬出日', renderbikeCarryingOutDate(bikeCarryingOutDate))}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatBikeParkingUseWithdrawalApplicationDocument.displayName = 'NatBikeParkingUseWithdrawalApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderbikeCarryingOutDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderWithdrawalDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <YearMonthContainer>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} margin={'0 2mm 0 auto'}>末日</Box>
        </YearMonthContainer>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    })

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`

const YearMonthContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
